import * as types from './mutation-types';

const mutations = {
  [types.CLEAR_REFERENCE_DATA](state) {
    state.allUnitDimensions = null;
    state.buyers = [];
    state.curators = [];
    state.dataProviders = [];
    state.demographics = [];
    state.externalDemographics = [];
    state.externalOrganizationDSPIDs = [];
    state.iabCategories = [];
    state.languages = [];
    state.locations = [];
    state.locationTreeSearchResults = [];
    state.mediaOwners = [];
    state.mediaTypes = [];
    state.networks = [];
    state.organizationDSPBuyersList = [];
    state.organizationDSPs = [];
    state.organizationDSPIDs = [];
    state.organizationExternalExchanges = [];
    state.sites = [];
    state.targetingCriteria = [];
  },

  [types.UPDATE_CHILDREN_LOCATIONS](state, payload) {
    const { location } = payload;
    const childLocations = payload.locations;
    location.locations = childLocations;
  },

  [types.UPDATE_BUYERS_LIST](state, buyers) {
    state.buyers = [...buyers].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_CURATORS_LIST](state, curators) {
    state.curators = [...curators].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_DATAPROVIDERS_LIST](state, dataProviders) {
    state.dataProviders = [...dataProviders].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_DEMOGRAPHICS_LIST](state, demographics) {
    state.demographics = [...demographics].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_EXTERNALDEMOGRAPHICS_LIST](state, externalDemographics) {
    state.externalDemographics = [...externalDemographics].sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    );
  },

  [types.UPDATE_ORGANIZATION_DSPS_LIST](state, odsps) {
    state.organizationDSPs = [...odsps].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_ORGANIZATION_DSP_BUYERS_LIST](state, odsps) {
    state.organizationDSPBuyersList = [...odsps]
      .map((x) => {
        return { ...x, displayName: `${x.name} ${x.dsp_name} ${x.seat_id}` };
      })
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_ORGANIZATION_DSP_IDS_LIST](state, odspIDs) {
    state.organizationDSPIDs = odspIDs;
  },

  [types.UPDATE_EXTERNAL_ORGANIZATION_DSP_IDS_LIST](state, odspIDs) {
    state.externalOrganizationDSPIDs = odspIDs;
  },

  [types.UPDATE_ORGANIZATION_EXTERNAL_EXCHANGES_LIST](state, exchanges) {
    state.organizationExternalExchanges = exchanges;
  },

  [types.UPDATE_IAB_CATEGORIES_LIST](state, iabCategories) {
    state.iabCategories = [...iabCategories].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_LANGUAGE_LIST](state, languages) {
    state.languages = [...languages];
  },

  [types.UPDATE_SITES_LIST](state, sites) {
    state.sites = [...sites].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_LOCATION_TREESEARCH_RESULTS](state, locations) {
    state.locationTreeSearchResults = locations;
  },

  [types.UPDATE_MARKETS_LIST](state, markets) {
    state.markets = [...markets].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_MEDIA_OWNERS_LIST](state, mediaOwners) {
    state.mediaOwners = [...mediaOwners].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_MEDIA_TYPES_LIST](state, mediaTypes) {
    state.mediaTypes = [...mediaTypes].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_NETWORKS_LIST](state, networks) {
    state.networks = [...networks].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_SUPPLIER_COUNTRY_ROOTS](state, countryRoots) {
    state.mediaOwnerCountryRoots = countryRoots;
  },

  [types.UPDATE_TARGETING_CRITERIA_LIST](state, targetingCriteria) {
    state.targetingCriteria = [...targetingCriteria].sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    );
  },

  [types.UPDATE_ALL_UNIT_DIMENSIONS](state, dimensions) {
    state.allUnitDimensions = [...dimensions].sort((a, b) => a - b);
  },
};

export default mutations;
